import { AppEvent } from 'types/appEvent';
import { PartnerDashboard } from 'types/partnerDashboardTypes';
import { createReducer } from 'utils/reducer/reducerUtils';
import { routes } from 'utils/routes';

export const reduceToNextPartnerDashboard = createReducer<
  PartnerDashboard,
  AppEvent
>((prev, event) => {
  switch (event.name) {
    case 'Router__PathnameChanged': {
      if (event.pathname === routes.clientsActive()) {
        return {
          ...prev,
          paidClientGroupsInvalidated: true,
          trialClientsInvalidated: true,
        };
      }

      if (event.pathname === routes.clientsCancelled()) {
        return {
          ...prev,
          cancelledClientsInvalidated: true,
        };
      }

      return prev;
    }
    case 'PartnerClientsPage__PaidClientsTableGroupsRecieved':
      return {
        ...prev,
        paidClientGroupsInvalidated: false,
        paidClientGroups: event.groups,
      };
    case 'PartnerClientsPage__TrialClientsTableItemsRecieved':
      return {
        ...prev,
        trialClientsInvalidated: false,
        trialClients: event.items,
      };
    case 'PartnerClientsPage__CancelledClientsTableItemsRecieved':
      return {
        ...prev,
        cancelledClientsInvalidated: false,
        cancelledClients: event.items,
      };
    default:
      return prev;
  }
});
